"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegisteredCharityDetails = exports.isIeRegisteredCharityNumberFormatValid = exports.isIeRegisteredCharityNumberValid = exports.normalizeIeRegisteredCharityNumber = exports.isIeRegisteredCharityNumberRequired = exports.usesIeCharityRegistrationFields = void 0;
const country_1 = require("../enums/country");
const usesIeCharityRegistrationFields = (country) => country === country_1.OrganizationCountry.Ireland;
exports.usesIeCharityRegistrationFields = usesIeCharityRegistrationFields;
const isIeRegisteredCharityNumberRequired = (country, croNumber) => (0, exports.usesIeCharityRegistrationFields)(country) && !croNumber?.trim();
exports.isIeRegisteredCharityNumberRequired = isIeRegisteredCharityNumberRequired;
const normalizeIeRegisteredCharityNumber = (registrationNumber) => registrationNumber ? registrationNumber.replace(/\s/g, "").replace(/^RCN/i, "") : registrationNumber;
exports.normalizeIeRegisteredCharityNumber = normalizeIeRegisteredCharityNumber;
const isIeRegisteredCharityNumberValid = (registrationNumber) => {
    const normalized = (0, exports.normalizeIeRegisteredCharityNumber)(registrationNumber);
    return Boolean(normalized) && /^20\d{6}$/.test(String(normalized));
};
exports.isIeRegisteredCharityNumberValid = isIeRegisteredCharityNumberValid;
const isIeRegisteredCharityNumberFormatValid = (country, registrationNumber) => {
    if (!(0, exports.usesIeCharityRegistrationFields)(country) || !registrationNumber?.trim()) {
        return true;
    }
    return (0, exports.isIeRegisteredCharityNumberValid)(registrationNumber);
};
exports.isIeRegisteredCharityNumberFormatValid = isIeRegisteredCharityNumberFormatValid;
const getRegisteredCharityDetails = (organization) => {
    if (!organization || !(0, exports.usesIeCharityRegistrationFields)(organization.country)) {
        return undefined;
    }
    const registeredName = organization.legalName?.trim() || organization.name;
    if (!registeredName || !(0, exports.isIeRegisteredCharityNumberValid)(organization.ieRegisteredCharityNumber)) {
        return undefined;
    }
    return {
        registeredName,
        registrationNumber: String((0, exports.normalizeIeRegisteredCharityNumber)(organization.ieRegisteredCharityNumber)),
    };
};
exports.getRegisteredCharityDetails = getRegisteredCharityDetails;
